// extracted by mini-css-extract-plugin
export default {"container":"FeelingStuck_container__WKmyI","textArea":"FeelingStuck_textArea__TsZVC","cta":"FeelingStuck_cta__F-NXr"};